<div v-if="page_type === 'register'">
  <div v-for="(field, index) in render_fields" :key="index" class="form-group">
    <!-- Text Input with Floating Label -->
    <div v-if="field.has_text">
      <div class="form-floating">
        <input 
          type="text" 
          class="form-control-nb bottom-border-input text-xs"
          placeholder=" "
          v-model="field.value" 
          :name="field.question"
          :id="`text_input_${index}`" />
        <label :for="`text_input_${index}`" class="fw-bold text-xs">
          {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
        </label>
      </div>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
    </div>

    <!-- Number Input with Floating Label -->
    <div v-if="field.has_number">
      <div class="form-floating">
        <input 
          type="number" 
          class="form-control-nb bottom-border-input text-xs"
          placeholder=" "
          v-model="field.value" 
          :name="field.question"
          :id="`number_input_${index}`" />
        <label :for="`number_input_${index}`" class="fw-bold text-xs">
          {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
        </label>
      </div>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
    </div>
    
    <!-- Radio Button Options -->
    <div v-if="field.has_checkbox">
      <label class="fw-bold text-xs text-start d-block mb-2">
        {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
      </label>
      <div class="d-flex flex-column gap-2">
        <div v-for="option in field.options" :key="option.id" class="form-check d-flex align-items-start radio-input-zero-padding">
          <input 
            type="radio" 
            class="form-check-input me-2 mt-1" 
            v-model="field.value" 
            :value="option.option"
            :id="`radio_${index}_${option.id}`" 
            :name="`radio_group_${index}`" 
            @change="get_follow_up_question(field.question_id, option.id)" />
          <label :for="`radio_${index}_${option.id}`" class="form-check-label text-start text-xs cursor-pointer">
            {{ option.option }}
          </label>
        </div>
      </div>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
    </div>

    <!-- Dropdown for Selections -->
    <div v-if="field.has_selection">
      <label class="fw-bold text-xs text-start d-block mb-2">
        {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
      </label>
      <SearchSelect
        v-if="field.options.length > 5"
        v-model="field.value"
        @change="get_follow_up_question(field.question_id, $event.target.value)"
        :options="field.options.map(option => ({ value: option.option, text: option.option }))"
        :placeholder="field.question"
      />
      <select
        v-else
        class="form-control-nb bottom-border-input text-xs w-100"
        v-model="field.value" 
        :id="`select_${index}`"
        @change="get_follow_up_question(field.question_id, $event.target.value)">
        <option value="" disabled hidden>Select an option</option>
        <option v-for="option in field.options" :key="option.id" :value="option.option">{{ option.option }}</option>
      </select>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
    </div>

    <!-- Multi-selection Checkboxes -->
      <div v-if="field.has_multi_selection">
      <label class="fw-bold text-xs text-start d-block mb-2">
        {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
      </label>
      <div class="d-flex flex-column gap-2">
        <div v-for="option in field.options" :key="option.option" class="form-check d-flex align-items-start">
          <input 
            type="checkbox"
            class="form-check-input me-2 mt-1"
            v-model="responses[index].value"
            :value="option.option"
            :id="`checkbox_${index}_${option.option}`"
            @change="handle_multiple_selection($event, field.question_id, option.id)" />
          <label :for="`checkbox_${index}_${option.option}`" class="form-check-label text-xs text-start">
            {{ option.option }}
          </label>
        </div>
      </div>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
      </div>

    <!-- File Input -->
      <div v-if="field.has_file">
      <label class="fw-bold text-xs text-start d-block mb-2">
        {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
      </label>
      <input
        type="file"
        accept=".pdf"
        @change="($event) => on_file_change($event, field.question_id, false)"
        ref="file_input"
        :name="`file_${field.question_id}`"
        class="form-control form-control-sm rounded text-xs w-100" />
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
      </div>

    <!-- Date Input with Floating Label -->
      <div v-if="field.has_date">
      <div class="form-floating">
        <input 
          type="date" 
          class="form-control-nb bottom-border-input text-xs"
          placeholder=" "
          v-model="field.value"
          :name="field.question"
          :id="`date_input_${index}`" />
        <label :for="`date_input_${index}`" class="fw-bold text-xs">
          {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
        </label>
      </div>
      <small :id="`error-${field.question_id}`" class="text-danger p-2 text-xxs fw-bold d-none">
        Please fill in this field
      </small>
      </div>

    <!-- Follow-up Questions Section -->
    <div v-if="follow_up_questions.length > 0" class="mt-4">
      <div v-for="follow_up in follow_up_questions" :key="follow_up.question_id">
        <div v-show="follow_up.parent_id === field.question_id" class="mb-4">
          <label class="text-xs text-start fw-bold d-block mb-2">
            {{ follow_up.question_text }}
            <span v-if="follow_up.is_required" class="text-danger">*</span>
          </label>

          <div class="form-group mt-2">
            <!-- Text Input -->
            <div v-if="follow_up.has_text" class="form-group mb-2 text-start">
              <input type="text"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm"
                v-model="follow_up.value" :placeholder="follow_up.question_text" :required="follow_up.is_required"
                @input="update_follow_up_response(follow_up.question_id, follow_up.value)" 
                :name="`follow_up_text_${follow_up.question_id}`"/>
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- Number Input -->
            <div v-if="follow_up.has_number" class="form-group mb-2 text-start">
              <input type="number"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm"
                v-model="follow_up.value" :placeholder="follow_up.question_text" :required="follow_up.is_required"
                @input="update_follow_up_response(follow_up.question_id, follow_up.value)"
                :name="`follow_up_file_${follow_up.question_id}`" />
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- Multi-selection Checkboxes -->
            <div v-if="follow_up.has_multi_selection" class="form-group mb-2 text-start">
              <div v-for="option in follow_up.options" :key="`${follow_up.question_id}_${option.option}`"
                class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm"
                  :checked="follow_up_responses.find(r => r.question_id === follow_up.question_id)?.value?.includes(option.option)"
                  :value="option.option"
                  :id="`follow_up_checkbox_${follow_up.question_id}_${option.option}`"
                  @change="handle_followup_multiple_selection($event, follow_up.question_id, option.option)" />
                <label :for="`follow_up_checkbox_${follow_up.question_id}_${option.option}`"
                  class="form-check-label text-xs ms-1">
                  {{ option.option }}
                </label>
              </div>
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- Single-selection Radio Buttons -->
            <div v-if="follow_up.has_checkbox" class="form-group mb-2">
              <div class="d-flex flex-column gap-2">
                <div v-for="option in follow_up.options" :key="`${follow_up.question_id}_${option.id}`" class="form-check d-flex align-items-start radio-input-zero-padding">
                  <input type="radio" class="form-check-input me-2 mt-1"
                    :name="`follow_up_radio_${follow_up.question_id}`" v-model="follow_up.value" :value="option.option"
                    @change="update_follow_up_response(follow_up.question_id, option.option)"
                    :id="`follow_up_radio_${follow_up.question_id}_${option.id}`" :required="follow_up.is_required" />
                  <label :for="`follow_up_radio_${follow_up.question_id}_${option.id}`"
                    class="form-check-label text-start text-xs cursor-pointer">
                    {{ option.option }}
                  </label>
                </div>
              </div>
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- Dropdown Selection -->
            <div v-if="follow_up.has_selection" class="form-group mb-2 text-xxs text-start">
              <SearchSelect
                v-if="follow_up.options.length > 5"
                v-model="follow_up.value"
                @change="update_follow_up_response(follow_up.question_id, $event.target.value)"
                :options="follow_up.options.map(option => ({ value: option.option, text: option.option }))"
                :placeholder="follow_up.question_text"
              />
              <select
                v-else
                class="form-select form-select-sm mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm"
                v-model="follow_up.value"
                @input="update_follow_up_response(follow_up.question_id, $event.target.value)"
                :required="follow_up.is_required">
                  <option value="" disabled hidden>{{ follow_up.question_text }}
                    <span v-if="follow_up.is_required" class="text-danger">*</span>
                  </option>
                  <option v-for="option in follow_up.options" :key="`${follow_up.question_id}_${option.option}`"
                    :value="option.option">
                    {{ option.option }}
                  </option>
              </select>
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- File Upload -->
            <div v-show="follow_up.has_file" class="form-group mb-2 text-start">
              <input
                type="file"
                accept=".pdf"
                @change="($event) => on_file_change($event, follow_up.question_id, true)"
                :ref="`followup_file_input_${follow_up.question_id}`"
                :name="`followup_file_${follow_up.question_id}`"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm" />
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>

            <!-- Date Input -->
            <div v-if="follow_up.has_date" class="form-group mb-2 text-start">
              <input type="date"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xs rounded-small p-2 shadow-sm"
                v-model="follow_up.value" :required="follow_up.is_required"
                @input="update_follow_up_response(follow_up.question_id, follow_up.value)" />
              <small :id="`error-followup-${follow_up.question_id}`" class=" text-danger fw-bold text-xxs d-none">
                Please fill in this field
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>